<template>
  <div id="scroll-board">
    <audio id="myAudio" loop>
      <source src="./voice/voice7.wav" type="audio/mpeg">
    </audio>
    <dv-scroll-board :config="config"/>
  </div>
</template>

<script>
  import moment from "moment";
  import {getAttributesClient, getCredentials} from "../untils/api/home";

  export default {
    name: 'ScrollBoard',
    data() {
      return {
        config: {
          header: [this.$t("time"), this.$t("warnInfo")],
          data: [],
          index: true,
          columnWidth: [50, 180, 300],
          align: ['center'],
          rowNum: 10,
          headerBGC: '#3E528B',//5664A0  51b9fb
          headerHeight: 45,
          oddRowBGC: 'rgba(0, 44, 81, 0.8)',
          evenRowBGC: 'rgba(10, 29, 50, 0.8)'
        },
        timer: '',
        configListObj: [],
        configListStr: '',
        deviceIdInfo: '',
        upList: [], //上限集合
        lowList: [], //下限集合
        oldListStr: ''
      }
    },

    methods: {
      /**
       * 获取遥测数据
       * @param deviceId  设备类型
       * @param deciveKey  最新遥测
       * @returns {Promise<unknown>}
       */
      getDevoceHistoryInfo(deviceId, latestResponse,deviceDefault) {
        //无数据 原先数据清空
        if (latestResponse === 'false' || JSON.stringify(latestResponse) == "{}") {
          const {config} = this;
          this.config.data = [];
          this.config = {...config};
          return;
        }
        if (this.deviceIdInfo !== deviceId.id) {
          document.getElementById('myAudio').pause();
          this.configListObj = [];
          this.configListStr = '';
          this.deviceIdInfo = deviceId.id;
        }
        console.log("ScrollBoardBefore", latestResponse);
        let newList = eval(localStorage.getItem("upLowList")); //获取本地设置的警报
        //本地警报为null 或 本地警报与上次警报一致
        if(newList === null || this.oldListStr === JSON.stringify(newList)){
          //筛选出超过上限或者低于下线的值
          // this.getUpLowData(this.upList, this.lowList, latestResponse);
          this.getCredentialsInfo(deviceDefault, latestResponse);
          this.oldListStr = JSON.stringify(JSON.stringify(newList));
        } else {
          //本地警报不为null 或 本地警报与上次警报不一致
          //获取最新的警报值
          this.getNewUpList(newList, latestResponse);
          this.oldListStr = JSON.stringify(JSON.stringify(newList));
        }
      },

      /**
       * 拆分最新警告值
       * @param newList  最新警告值
       * @param latestResponse  最新遥测值
       */
      getNewUpList(newList, latestResponse){
        let newUpList = []; //最新最低报警值
        let newLowList = [];//最新最高报警值
        for(let i = 0; i < newList.length; i++){
         for(let obj in newList[i]){
           if (obj.substring(obj.length - 3) === '_up') {
             let upJson = {};
             upJson.name = obj.substring(0, obj.length - 3);
             upJson.value = parseFloat(newList[i][obj]);
             newUpList.push(upJson);
           }else if (obj.substring(obj.length - 4) === '_low') {
             //获取遥测数据下限值
             let lowJson = {};
             lowJson.name = obj.substring(0, obj.length - 4);
             lowJson.value = parseFloat(newList[i][obj]);
             newLowList.push(lowJson)
           }
         }
        }
        //将当前的警报值设置为最新警报值
        this.setUpLowList(newUpList, newLowList, latestResponse);
      },

      /**
       * 将当前的警报值设置为最新警报值
       * @param newUpList  最新警告上限值
       * @param newLowList  最新警告下限值
       * @param latestResponse  最新遥测值
       */
      setUpLowList(newUpList, newLowList, latestResponse){
        //将当前的警报上限值设置为最新警报值
        for(let i in newUpList){
          let upFlg = false;
          for(let j in this.upList){
            if(this.upList[j].name === newUpList[i].name){
              this.upList[j].value = parseFloat(newUpList[i].value);
              upFlg = true;
            }
          }
          if(!upFlg){
            this.upList.push(newUpList[i]);
          }
        }
        //将当前的警报下限值设置为最新警报值
        for(let i in newLowList){
          let lowFlg = false;
          for(let j in this.lowList){
            if(this.lowList[j].name === newLowList[i].name){
              this.lowList[j].value = parseFloat(newLowList[i].value);
              lowFlg = true;
            }
          }
          if(!lowFlg) {
            this.lowList.push(newLowList[i]);
          }
        }
        //筛选出超过上限或者低于下线的值
        this.getUpLowData(this.upList, this.lowList, latestResponse);

      },

      /**
       * 根据选中的值获取设备数据
       * @param deviceId
       */
      getCredentialsInfo(deviceId, latestResponse){
        if(latestResponse == undefined) return
        this.upList = [];
        this.lowList = [];
        //访问api获取设备信息
        getCredentials(deviceId).then(response => {
          //获取客户端遥测数据上下限值
          this.getUpLow(response.credentialsId, latestResponse);
        }).catch(error => {
          console.log("error", error)
        })
      },

      /**
       * 获取客户端遥测数据上下限值
       * @param credentialsId
       */
      getUpLow(credentialsId,latestResponse) {
        //访问api
        getAttributesClient(credentialsId).then(response => {
          for (let obj in response.client) {
            if (obj.substring(obj.length - 3) === '_up') {
              //获取遥测数据上限值
              let upJson = {};
              upJson.name = obj.substring(0, obj.length - 3);
              upJson.value = response.client[obj];
              this.upList.push(upJson);
            } else if (obj.substring(obj.length - 4) === '_low') {
              //获取遥测数据下限值
              let lowJson = {};
              lowJson.name = obj.substring(0, obj.length - 4);
              lowJson.value = response.client[obj];
              this.lowList.push(lowJson);
            }
          }
          //筛选出超过上限或者低于下线的值
          this.getUpLowData(this.upList, this.lowList, latestResponse);
          //this.getUpLowData(this.upList, this.lowList, latestResponse);
        }).catch(error => {
          console.log("error", error)
        })
      },

      /**
       * 筛选出超过上限或者低于下线的值
       * @param upList  上限
       * @param lowList  下限
       * @latestResponse  最新遥测数据
       */
      getUpLowData(upList, lowList, latestResponse) {
        let configList = [];
        let configObj = [];
        let snowRefer = localStorage.getItem('snowRefer'); //获取设置雪深值
        let levelRefer = localStorage.getItem('levelRefer');//获取设置的水位值
        let noiseRefer = localStorage.getItem('noiseRefer');//获取设置噪声值
        let amnitroResult = 0;
        if(latestResponse.hasOwnProperty('ammoniaIon')) {
          if(latestResponse.hasOwnProperty('waterPH')) {
            let amnitro = parseFloat(latestResponse['ammoniaIon'][0].value);
            let waterPH = parseFloat(latestResponse['waterPH'][0].value);
            if(latestResponse.hasOwnProperty('waterT')){
              let waterT = parseFloat(latestResponse['waterT'][0].value);
              let result = amnitro * Math.pow(10, waterPH - (-0.032 * waterT + 10.042)) + amnitro;
              amnitroResult = parseFloat(result).toFixed(2);
            } else {
              let result = amnitro * Math.pow(10, (waterPH - 9.25)) + amnitro;
              amnitroResult = parseFloat(result).toFixed(2);
            }
          } else {
            amnitroResult = parseFloat(latestResponse['ammoniaIon'][0].value)
          }
        } else {
          amnitroResult = 0;
        }

        for (let obj in latestResponse) {
          for (let up in upList) {
            //筛选出符合上限的值
            if((obj === upList[up].name) && (obj == "snowHeight" || obj == "snowheight") && (Math.abs(parseFloat(snowRefer) +  parseFloat(latestResponse[obj][0].value)) > upList[up].value)) {
              let unit = this.$t(obj).split(',')[1] === undefined ? '' : this.$t(obj).split(',')[1];
              let des = this.$t(obj).split(',')[0] + this.$t('is') + (Math.abs(parseFloat(snowRefer) +  parseFloat(latestResponse[obj][0].value))).toFixed().toString()+ unit + this.$t('upMessage');
              configList.push(['<span style="color:#FF0000; font-weight: bold">' + this.dateFormat(latestResponse[obj][0].ts) + '</span>', '<span style="color:#FF0000; font-weight: bold">' + des + '</span>']);
              configObj.push(obj.toString());
              break;
            } else if((obj === upList[up].name) && (obj == "level" || obj == "Rwater" || obj == "waterlevel") && (Math.abs(parseFloat(levelRefer) +  parseFloat(latestResponse[obj][0].value)) > upList[up].value)) {
              let unit = this.$t(obj).split(',')[1] === undefined ? '' : this.$t(obj).split(',')[1];
              let des = this.$t(obj).split(',')[0] + this.$t('is') + (Math.abs(parseFloat(levelRefer) +  parseFloat(latestResponse[obj][0].value)))+ unit + this.$t('upMessage');
              configList.push(['<span style="color:#FF0000; font-weight: bold">' + this.dateFormat(latestResponse[obj][0].ts) + '</span>', '<span style="color:#FF0000; font-weight: bold">' + des + '</span>']);
              configObj.push(obj.toString());
              break;
            } else if((obj === upList[up].name) && (obj == "noise" || obj == "noi" || obj == "noise1" || obj == "noise2") && (Math.abs(parseFloat(noiseRefer) +  parseFloat(latestResponse[obj][0].value)) > upList[up].value)) {
              let unit = this.$t(obj).split(',')[1] === undefined ? '' : this.$t(obj).split(',')[1];
              let des = this.$t(obj).split(',')[0] + this.$t('is') + (Math.abs(parseFloat(noiseRefer) +  parseFloat(latestResponse[obj][0].value))).toFixed(1).toString()+ unit + this.$t('upMessage');
              configList.push(['<span style="color:#FF0000; font-weight: bold">' + this.dateFormat(latestResponse[obj][0].ts) + '</span>', '<span style="color:#FF0000; font-weight: bold">' + des + '</span>']);
              configObj.push(obj.toString());
              break;
            } else if((obj === upList[up].name) && (obj == "ammoniaIon") && (parseFloat(amnitroResult) > upList[up].value)) {
              let unit = this.$t(obj).split(',')[1] === undefined ? '' : this.$t(obj).split(',')[1];
              let des = this.$t(obj).split(',')[0] + this.$t('is') + (parseFloat(amnitroResult)).toFixed(2).toString()+ unit + this.$t('upMessage');
              configList.push(['<span style="color:#FF0000; font-weight: bold">' + this.dateFormat(latestResponse[obj][0].ts) + '</span>', '<span style="color:#FF0000; font-weight: bold">' + des + '</span>']);
              configObj.push(obj.toString());
              break
            } else if((obj === upList[up].name) && (obj == "flowNum") && (parseFloat(latestResponse[obj][0].value) * 6.28 > upList[up].value)) {
              let unit = this.$t(obj).split(',')[1] === undefined ? '' : this.$t(obj).split(',')[1];
              let des = this.$t(obj).split(',')[0] + this.$t('is') + (parseFloat(latestResponse[obj][0].value) * 6.28).toFixed(2).toString()+ unit + this.$t('upMessage');
              configList.push(['<span style="color:#FF0000; font-weight: bold">' + this.dateFormat(latestResponse[obj][0].ts) + '</span>', '<span style="color:#FF0000; font-weight: bold">' + des + '</span>']);
              configObj.push(obj.toString());
              break
            } else if((obj === upList[up].name) && (obj == "Rday1") && (parseFloat(latestResponse[obj][0].value) * 0.36 > upList[up].value)) {
              let unit = this.$t(obj).split(',')[1] === undefined ? '' : this.$t(obj).split(',')[1];
              let des = this.$t(obj).split(',')[0] + this.$t('is') + (parseFloat(latestResponse[obj][0].value) * 0.36).toFixed(2).toString()+ unit + this.$t('upMessage');
              configList.push(['<span style="color:#FF0000; font-weight: bold">' + this.dateFormat(latestResponse[obj][0].ts) + '</span>', '<span style="color:#FF0000; font-weight: bold">' + des + '</span>']);
              configObj.push(obj.toString());
            } else if ((obj === upList[up].name) && (obj != "snowHeight") && (obj != "snowheight") && (obj != "level") && (obj != "Rwater") && (obj != "waterlevel") && (obj != "noise")
              && (obj != "noi") && (obj != "noise1'") && (obj != "noise2") && (obj != "ammoniaIon") && (obj != "flowNum") && (obj != "Rday1") && (latestResponse[obj][0].value > upList[up].value)) {
              let unit = this.$t(obj).split(',')[1] === undefined ? '' : this.$t(obj).split(',')[1];
              let des = this.$t(obj).split(',')[0] + this.$t('is') + parseFloat(latestResponse[obj][0].value).toFixed(2) + unit + this.$t('upMessage');
              configList.push(['<span style="color:#FF0000; font-weight: bold">' + this.dateFormat(latestResponse[obj][0].ts) + '</span>', '<span style="color:#FF0000; font-weight: bold">' + des + '</span>']);
              configObj.push(obj.toString());
              break;
            }
          }
          for (let low in lowList) {
            //筛选出符合下限的值
            if((obj === lowList[low].name) && (obj == "snowHeight" || obj == "snowheight") &&  (Math.abs(parseFloat(snowRefer) +  parseFloat(latestResponse[obj][0].value)) < lowList[low].value)) {
              let unit = this.$t(obj).split(',')[1] === undefined ? '' : this.$t(obj).split(',')[1];
              let des = this.$t(obj).split(',')[0] + this.$t('is') +  (Math.abs(parseFloat(snowRefer) +  parseFloat(latestResponse[obj][0].value))).toFixed().toString()+ unit +  this.$t('lowMessage');
              configList.push(['<span style="color:#FF0000; font-weight: bold">' + this.dateFormat(latestResponse[obj][0].ts) + '</span>', '<span style="color:#FF0000; font-weight: bold">' + des + '</span>']);
              configObj.push(obj.toString());
              break;
            } else if((obj === lowList[low].name) && (obj == "level" || obj == "Rwater" || obj == "waterlevel") &&  (Math.abs(parseFloat(levelRefer) +  parseFloat(latestResponse[obj][0].value)) < lowList[low].value)) {
              let unit = this.$t(obj).split(',')[1] === undefined ? '' : this.$t(obj).split(',')[1];
              let des = this.$t(obj).split(',')[0] + this.$t('is') +  (Math.abs(parseFloat(levelRefer) +  parseFloat(latestResponse[obj][0].value)))+ unit +  this.$t('lowMessage');
              configList.push(['<span style="color:#FF0000; font-weight: bold">' + this.dateFormat(latestResponse[obj][0].ts) + '</span>', '<span style="color:#FF0000; font-weight: bold">' + des + '</span>']);
              configObj.push(obj.toString());
              break;
            } else if((obj === lowList[low].name) && (obj == "noise" || obj == "noi" || obj == "noise1" || obj == "noise2") &&  (Math.abs(parseFloat(noiseRefer) +  parseFloat(latestResponse[obj][0].value)) < lowList[low].value)) {
              let unit = this.$t(obj).split(',')[1] === undefined ? '' : this.$t(obj).split(',')[1];
              let des = this.$t(obj).split(',')[0] + this.$t('is') +  (Math.abs(parseFloat(noiseRefer) +  parseFloat(latestResponse[obj][0].value))).toFixed(1).toString()+ unit +  this.$t('lowMessage');
              configList.push(['<span style="color:#FF0000; font-weight: bold">' + this.dateFormat(latestResponse[obj][0].ts) + '</span>', '<span style="color:#FF0000; font-weight: bold">' + des + '</span>']);
              configObj.push(obj.toString());
              break;
            } else if((obj === lowList[low].name) && (obj == "ammoniaIon") && (parseFloat(amnitroResult) < lowList[low].value)){
              let unit = this.$t(obj).split(',')[1] === undefined ? '' : this.$t(obj).split(',')[1];
              let des = this.$t(obj).split(',')[0] + this.$t('is') +  (parseFloat(amnitroResult)).toFixed(2).toString() + unit +  this.$t('lowMessage');
              configList.push(['<span style="color:#FF0000; font-weight: bold">' + this.dateFormat(latestResponse[obj][0].ts) + '</span>', '<span style="color:#FF0000; font-weight: bold">' + des + '</span>']);
              configObj.push(obj.toString());
              break;
            } else if((obj === lowList[low].name) && (obj == "flowNum") && (parseFloat(latestResponse[obj][0].value) * 6.28 < lowList[low].value)) {
              let unit = this.$t(obj).split(',')[1] === undefined ? '' : this.$t(obj).split(',')[1];
              let des = this.$t(obj).split(',')[0] + this.$t('is') +  (parseFloat(latestResponse[obj][0].value) * 6.28).toFixed(2).toString() + unit +  this.$t('lowMessage');
              configList.push(['<span style="color:#FF0000; font-weight: bold">' + this.dateFormat(latestResponse[obj][0].ts) + '</span>', '<span style="color:#FF0000; font-weight: bold">' + des + '</span>']);
              configObj.push(obj.toString());
              break;
            } else if((obj === lowList[low].name) && (obj == "Rday1") && (parseFloat(latestResponse[obj][0].value) * 0.36 < lowList[low].value)) {
              let unit = this.$t(obj).split(',')[1] === undefined ? '' : this.$t(obj).split(',')[1];
              let des = this.$t(obj).split(',')[0] + this.$t('is') +  (parseFloat(latestResponse[obj][0].value) * 0.36).toFixed(2).toString() + unit +  this.$t('lowMessage');
              configList.push(['<span style="color:#FF0000; font-weight: bold">' + this.dateFormat(latestResponse[obj][0].ts) + '</span>', '<span style="color:#FF0000; font-weight: bold">' + des + '</span>']);
              configObj.push(obj.toString());
              break;
            } else if (obj === lowList[low].name && (obj != "snowHeight") && (obj != "snowheight") && (obj != "level") && (obj != "Rwater") && (obj != "waterlevel") && (obj != "noise")
              && (obj != "noi") && (obj != "noise1'") && (obj != "noise2")  && (obj != "ammoniaIon") &&  (obj != "flowNum") &&  (obj != "Rday1") && latestResponse[obj][0].value < lowList[low].value) {
              let unit = this.$t(obj).split(',')[1] === undefined ? '' : this.$t(obj).split(',')[1];
              let des = this.$t(obj).split(',')[0] + this.$t('is') + parseFloat(latestResponse[obj][0].value).toFixed(2) + unit +  this.$t('lowMessage');
              configList.push(['<span style="color:#FF0000; font-weight: bold">' + this.dateFormat(latestResponse[obj][0].ts) + '</span>', '<span style="color:#FF0000; font-weight: bold">' + des + '</span>']);
              configObj.push(obj.toString());
              if(obj.indexOf('soilHumi') > -1) {
                let _this = this;
                setTimeout(function () {
                  _this.$message({
                    showClose: true,
                    type: "error",
                    message: _this.$t(obj).split(',')[0] + '较低，请及时灌溉',
                    duration: 1000 * 10
                  });
                }, 1)
              }
              break;
            }
          }
        }

        //设置config data
        this.setConfigData(configList);
        //判断警报是否出现
        //警报数量多于现存警报数
        if (configList.length > 0 && this.configListObj.length < configObj.length) {
          this.configListObj = configObj;
          this.configListStr = configList.toString();
          this.playMusic();
        } else if (configList.length > 0 && this.configListObj.length > configObj.length) {
          //警报数量小于等于现存警报数
          // for (let i = configObj.length - 1; i >= 0; i--) {
          //   //判断上次数据是否包含本次数据
          //   if (this.configListObj.indexOf(configObj[i]) < 0) {
          //     this.playMusic();
          //     break;
          //   }
          // }
          if (this.configListStr !== configList.toString()) {
            this.playMusic();
          }
          this.configListObj = configObj;
          this.configListStr = configList.toString();
        } else if (this.configListObj.length === configObj.length) {
          //警报数量等于现存警报数
          if (this.configListStr !== configList.toString()) {
            this.playMusic();
          }
          this.configListObj = configObj;
          this.configListStr = configList.toString();
        } else if (configList.length === 0) {
          this.configListObj = [];
          this.configListStr = '';
        }
      },

      /**
       * 设置警报响起
       */
      playMusic() {
        clearTimeout(this.timer); //清除延迟执行
        document.getElementById('myAudio').play();
        this.timer = setTimeout(() => { //设置延迟执行
          document.getElementById('myAudio').pause();
        }, 1000 * 8);
      },

      /**
       * 设置config data
       * @param historyInfo
       */
      setConfigData(configList) {
        const {config} = this;
        //对data 重新赋值
        this.config.data = configList;
        this.config = {...config};
        console.log("ScrollBoardAfterInfo", this.config.data)
      },

      //格式化时间戳
      dateFormat(timestamp) {
        if (timestamp && timestamp != "") {
          let dateStr = moment(timestamp).format('YYYY-MM-DD HH:mm:ss');
          return dateStr;
        }
        return "-";
      },
    }
  }
</script>

<style lang="less">
  @import "less/scrollBoard.less";
</style>



// WEBPACK FOOTER //
// src/components/ScrollBoard.vue